let lenisInstance = null;

export const setLenis = (instance) => {
    lenisInstance = instance;
};

export const getLenis = () => lenisInstance;
